<template>
  <div id="product-pdf-dialog" class="text-xs-center">
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-text>
          <v-select v-model="selectedTemplate" :items="viewingTemplates" :label="$t('product_pdf_dialog.template')"></v-select>
          {{$t('product_pdf_dialog.selected')}}: {{selected.length}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="templateNotSelected"
            flat
            @click="print"
          >{{$t('product_pdf_dialog.print')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Export from "@/models/Export.js";
export default {
  name: "product-pdf-dialog",
  props: {
    templates: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      dialog: false,
      selected: [],
      viewingTemplates: [],
      selectedTemplate: null,
    };
  },
  computed: {
    templateNotSelected() {
      return this.selectedTemplate == null;
    },
  },
  created() {
    this.templates.forEach((template) => {
      this.viewingTemplates.push({
        text: template.name,
        value: template.id,
      });
    });
  },
  methods: {
    open(selected) {
      this.selected = selected;
      this.dialog = true;
    },
    print() {
      Export.productTemplateExport(this.selectedTemplate, this.selected);
    },
  },
};
</script>

<style scoped>
</style>